import { Routes } from '@angular/router';
import { authGuard } from '@coin/shared/auth/feature';
import { AuthGmsClientCallbackComponent, LoginScreenComponent, LogoutScreenComponent } from '@coin/shared/auth/feature';
import { NoBackendScreenComponent } from '@coin/shared/core/feature-legacy-components';
import { FrontendType } from '@coin/shared/core/util-enums';
import { SOC_ROUTING_COMPATIBILITY_ROUTES } from './soc-routing-compatibility/soc-routing-compatibility.routes';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';

export const APP_ROUTES: Routes = [
  {
    path: '',
    canActivate: [authGuard],
    data: {
      isHeaderSearchBarVisible: false,
      frontendType: FrontendType.cosmos
    },
    pathMatch: 'full',
    loadChildren: () => import('./home/home.routes')
  },
  {
    path: 'logout',
    component: LogoutScreenComponent
  },
  {
    path: 'login',
    component: LoginScreenComponent
  },
  {
    path: 'org-management',
    canActivate: [authGuard],
    data: {
      frontendType: FrontendType.cosmos
    },
    loadChildren: () => import('./org-management/org-management.routes')
  },
  {
    path: 'legal-entities',
    canActivate: [authGuard],
    data: {
      frontendType: FrontendType.cosmos
    },
    loadChildren: () => import('./legal-entities/legal-entities.routes')
  },
  {
    path: 'auth/callback',
    component: AuthGmsClientCallbackComponent
  },
  {
    path: 'unauthorized',
    component: UnauthorizedComponent,
    data: {
      isHeaderSearchBarVisible: false
    }
  },
  {
    path: 'fallback',
    component: NoBackendScreenComponent
  },
  ...SOC_ROUTING_COMPATIBILITY_ROUTES,
  {
    path: '**',
    redirectTo: '/'
  }
];
